import React, { useState } from "react";
import { Image, Toast } from "react-bootstrap";
import Draggable from "react-draggable";
import AnimatedCol from "../../../../components/AnimatedCol";
import HiddenWrapperRow from "../../../../components/UI/HiddenWrapperRow";
import imageDE from "../../../../images/Aashto/20231009_ResistanceFactor_DE.png";
import imageES from "../../../../images/Aashto/20231009_ResistanceFactor_ES.png";
import imageEN from "../../../../images/Aashto/20231009_ResistanceFactor_EN.png";

import ResistanceFactor from "./ResistanceFactor";
import { useTranslation } from "react-i18next";

function ResistanceFactorWithImage() {
  const { i18n } = useTranslation("translation");
  const [showImage, setShowImage] = useState(false);

  return (
    <>
      <AnimatedCol>
        <ResistanceFactor showImage={setShowImage} show={showImage} />
      </AnimatedCol>
      <HiddenWrapperRow>
        <ShowImageDetails
          show={showImage}
          setShow={setShowImage}
          image={
            i18n.language === "de-DE" ? imageDE : i18n.language === "es-ES" ? imageES : imageEN
          }
        />
      </HiddenWrapperRow>
    </>
  );
}

export default ResistanceFactorWithImage;

function ShowImageDetails({ show, setShow, image }) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable nodeRef={nodeRef}>
      <Toast
        ref={nodeRef}
        onClose={() => setShow(!show)}
        show={show}
        animation={false}
        style={{
          zIndex: 1000,
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          height: "auto",
        }}
      >
        <Toast.Header className="d-flex flex-row-reverse"></Toast.Header>
        <Toast.Body>
          <Image src={image} alt="" width={700} />
        </Toast.Body>
      </Toast>
    </Draggable>
  );
}
